import { InputValidationProperty } from '../enums';

const InputValidationProps = {
  props: {
    [InputValidationProperty.IsShowErrorMessage]: {
      default: false,
      type: Boolean,
    },
    [InputValidationProperty.ErrorMessage]: {
      default: '',
      type: String,
    },
    [InputValidationProperty.IsRequired]: {
      default: false,
      type: Boolean,
    },
    [InputValidationProperty.Mask]: {
      default: '',
      type: String,
    },
    [InputValidationProperty.Pattern]: {
      default: null,
      type: [String, Object],
    },
  },
};

export default InputValidationProps;
